import { render, staticRenderFns } from "./AdminSubzonesTableRow.vue?vue&type=template&id=c8081956&"
import script from "./AdminSubzonesTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminSubzonesTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports